import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { MenuServices } from '../../menu/services';
import { CartaServices } from '../../carta/services';


@Component({
  selector: 'comp-flags-lang',
  templateUrl: 'flags-lang.html',
})
export class FlagsLangPage {
  @Input() lang;
  @Input() origin;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public menuServices: MenuServices,
    public cartaServices: CartaServices) {
  }

  changeLang(lang) {
    if (this.origin === 'menu') {
      this.menuServices.menu_lang = lang;
    } else {
      this.cartaServices.carta_lang = lang;
    }

  }
}



// WEBPACK FOOTER //
// ./src/pages/components/flags-lang/flags-lang.ts